import { TWhiteLabelStore } from '../white-label.model';

export function setPanelText(themeWrapper: HTMLBodyElement, whiteLabel: TWhiteLabelStore): void {
  themeWrapper.style.setProperty('--panelText', whiteLabel.data.panelText);
}
